import clsx from 'clsx'
import { Table } from 'components/core-v2'
import Highcharts from 'highcharts'
import sunburst from 'highcharts/modules/sunburst.js'
import { ClassName } from 'types/props'

import { CURRENCY } from '../../../../../const'
import { formatCurrencyFull } from '../../../../../utilities/currency'
import { plural } from '../../../../../utilities/plural'
import { SunburstChart } from '../sunburst-chart'
import { BasePoint, ChartOptionsProps } from '../sunburst-chart/chart-options'
import classes from './index.module.scss'
import { COLUMN_DEFS, DEFAULT_COLUMN_DEFS, getTableRowData } from './table-options'

export * from './loading'

sunburst(Highcharts)

export interface ValueCountPoint extends BasePoint {
  count?: number
  name: string
}

interface Props extends ClassName, Omit<ChartOptionsProps<ValueCountPoint>, 'tooltipFormatter'> {
  tableWidth?: string
}

export const ValueSunburstWithTable = ({
  allowTooltipOutside,
  className,
  data,
  seriesName,
  tableWidth = '100%'
}: Props) => {
  const tableRowData = getTableRowData(data)

  return (
    <div className={clsx('center', className)}>
      <div className={classes.chartWrapper}>
        <SunburstChart
          allowTooltipOutside={allowTooltipOutside}
          data={data}
          seriesName={seriesName}
          tooltipFormatter={that => {
            const { point, series } = that
            const { parent } = point.options

            // Inner ring
            if (parent === '0') {
              const formattedValue = formatCurrencyFull((point as any).value, CURRENCY)
              const childCount = (point as any).node.children.length
              if (childCount) {
                return `<div class="sunburst-chart-tooltip-wrapper"><h2>${series.name}</h2><p>${
                  point.name
                }: ${childCount} ${plural(
                  'trade',
                  childCount
                )} </p><p>Value: ${formattedValue}</p></div>`
              }
              return `<div class="sunburst-chart-tooltip-wrapper"><h2>${series.name}</h2><p>${point.name}</p><p>Value: ${formattedValue}</p></div>`
            }

            // Outer ring
            const formattedValue = formatCurrencyFull(point.options.value, CURRENCY)
            return `<div class="sunburst-chart-tooltip-wrapper"><h2>${series.name}</h2><p>${point.name}</p><p>Value: ${formattedValue}</p></div>`
          }}
        />
      </div>
      <Table
        agGridProps={{
          columnDefs: COLUMN_DEFS,
          defaultColDef: DEFAULT_COLUMN_DEFS,
          headerHeight: 60,
          rowData: tableRowData,
          rowHeight: 44
        }}
        className={classes.tableWrapper}
        width={tableWidth}
      />
    </div>
  )
}
